<div class="flex flex-col h-full w-full pb-8">
  <!-- Logo + Close -->
  <div class="flex justify-between items-center p-4 h-auto">
    <!-- Logo -->
    <div class="w-30 h-auto">
      <img class="w-90 h-auto" src="images/logo/logo.svg" />
    </div>

    <!-- Close button -->
    <button mat-icon-button (click)="closeDialog()" class="icon-size-2" *ngIf="shouldShowCloseButton()">
      <mat-icon>close</mat-icon>
    </button>

  </div>

  <!-- Title -->
  <div class="text-center mb-6">
    <h1 class="text-3xl md:text-3xl font-dm font-semibold text-ferrerText!">{{'register.title' | transloco}}</h1>
    <p class="text-base md:text-base font-dm text-ferrerSecondary mt-1">{{'register.emailVerified' | transloco}}</p>
    <p class="text-base md:text-base mt-2">
      {{'register.accountExist' | transloco}} <a (click)="openRegisterDialog()"
        class="text-[#006E75] hover:text-[#003E42] hover:underline font-medium cursor-pointer underline">{{'login.loginBtn'
        | transloco}}</a>
    </p>
  </div>


  <!--div form group-->
  <div class="mt-3 mb-6">
    <!-- Form Fields -->
    <form class="space-y-6 mt-2 mb-2" [formGroup]="registrationForm" (ngSubmit)="onSubmit()" autocomplete="off">
      <!-- Name -->
      <div class="mb-1 floating-label">
        <input type="text" id="name" required formControlName="firstName"
          [placeholder]="'registerPlaceholders.nameplaceholder' | transloco" autocomplete="off"
          class="w-full border border-ferrerSecondary rounded-2xl focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent"
          [ngClass]="{'border-red-500': registrationForm.get('firstName')?.invalid && registrationForm.get('firstName')?.touched}" />
        <label for="firstName" class="floating-label">{{'registerPlaceholders.nameplaceholder' | transloco}}</label>
        <div *ngIf="registrationForm.get('firstName')?.invalid && registrationForm.get('firstName')?.touched"
          class="text-base text-red-500 mt-1 ml-2 flex items-center">
          <mat-icon class="text-red-500 mr-1"
            style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
          <div *ngIf="registrationForm.get('firstName')?.errors?.['required']">
            {{'validations.nameRequired' | transloco}}
          </div>
          <div *ngIf="registrationForm.get('firstName')?.errors?.['minlength']">
            {{'validations.nameMinLength' | transloco}}
          </div>
          <div
            *ngIf="registrationForm.get('firstName')?.errors?.['pattern'] && !registrationForm.get('firstName')?.errors?.['minlength']">
            {{'validations.namePattern' | transloco}}
          </div>
        </div>
      </div>

      <!-- Surname -->
      <div class="mb-1 floating-label">
        <input type="text" required formControlName="lastName" id="surname"
          [placeholder]="'registerPlaceholders.surnameplaceholder' | transloco" autocomplete="off"
          class="w-full border border-ferrerSecondary rounded-2xl focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent"
          [ngClass]="{'border-red-500': registrationForm.get('lastName')?.invalid && registrationForm.get('lastName')?.touched}" />
        <label for="lastName" class="floating-label">{{'registerPlaceholders.surnameplaceholder' | transloco}}</label>
        <div *ngIf="registrationForm.get('lastName')?.invalid && registrationForm.get('lastName')?.touched"
          class="text-base text-red-500 flex items-center mt-1 ml-2">
          <mat-icon class="text-red-500 mr-1"
            style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
          <div *ngIf="registrationForm.get('lastName')?.errors?.['required']">
            {{'validations.surnameRequired' | transloco}}
          </div>
          <div *ngIf="registrationForm.get('lastName')?.errors?.['minlength']">
            {{'validations.surnameMinLength' | transloco}}
          </div>
          <div
            *ngIf="registrationForm.get('lastName')?.errors?.['pattern'] && !registrationForm.get('lastName')?.errors?.['minlength']">
            {{'validations.surnamePattern' | transloco}}
          </div>
        </div>
      </div>


      <!-- Password -->
      <div class="relative mb-1 floating-label password-field flex flex-col flex-grow">
        <input type="password" required formControlName="password" id="regpassword"
          placeholder="Crea tu contraseña (obligatorio)" autocomplete="new-password" #regpassword
          class="w-full border border-ferrerSecondary rounded-2xl focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent"
          [ngClass]="{'border-red-500': registrationForm.get('password')?.invalid && registrationForm.get('password')?.touched}" />
        <label for="regpassword" class="floating-label">{{'register.emailVerified_PasswordCreation' |
          transloco}}</label>
        <button mat-icon-button type="button" class="toggle-password absolute" (click)="
      regpassword.type === 'password'
              ? (regpassword.type = 'text')
              : (regpassword.type = 'password')
      " matSuffix>
          @if (regpassword.type === 'password') {
          <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:eye'"></mat-icon>
          }
          @if (regpassword.type === 'text') {
          <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:eye-slash'"></mat-icon>
          }
        </button>
        <p *ngIf="!registrationForm.get('password')?.invalid || !registrationForm.get('password')?.touched"
          class="text-base md:text-base text-gray-400 mt-2 ml-1">
          {{'register.emailVerified_PasswordTip' | transloco}}
        </p>
        <!-- Error messages -->
        <div *ngIf="registrationForm.get('password')?.invalid && registrationForm.get('password')?.touched"
          class="text-base text-red-500 mt-1 ml-2 flex items-center">
          <mat-icon class="text-red-500 mr-1"
            style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
          <div *ngIf="registrationForm.get('password')?.errors?.['required']">
            {{'validations.passwordRequired' | transloco}}
          </div>
          <div *ngIf="registrationForm.get('password')?.errors?.['minlength']">
            {{'validations.passwordLength' | transloco}}
          </div>
          <div *ngIf="registrationForm.get('password')?.errors?.['maxlength']">
            {{'validations.passwordLength' | transloco}}
          </div>
        </div>
      </div>
      <hr class="my-6" />

      <!-- Professional Area Dropdown -->
      <div class="mb-0 relative custom-dropdown-floating-label placeholder-base!" [ngClass]="{'has-value': registrationForm.get('profession')?.value,
      'has-error': registrationForm.get('profession')?.invalid && registrationForm.get('profession')?.touched
 }">
        <label for="professionalAreaTrigger" *ngIf="registrationForm.get('profession')?.value">
          {{'registerPlaceholders.professionalAreaplaceholder' | transloco}}
        </label>
        <!-- Dropdown Header -->
        <div id="professionalAreaTrigger" (click)="toggleProfessionalAreaDropdown($event)"
          class="w-full border border-ferrerSecondary rounded-2xl focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent cursor-pointer flex justify-between items-center text-ferrerText"
          [ngClass]="{'border-red-500': registrationForm.get('profession')?.invalid && registrationForm.get('profession')?.touched}">
          <span class="text-ferrerText!">
            {{ getProfessionalAreaLabel(registrationForm.get('profession')?.value) ||
            ('registerPlaceholders.professionalAreaplaceholder' | transloco) }}
          </span>
          <svg class="h-5 w-5 text-gray-500 transition-transform duration-200"
            [ngClass]="{'transform rotate-180': isProfessionalAreaOpen}" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 011.08 1.04l-4.25 4.25a.75.75 0 01-1.08 0l-4.25-4.25a.75.75 0 01.02-1.06z"
              clip-rule="evenodd" />
          </svg>
        </div>


        <!-- Dropdown Menu (Hidden by default) -->
        <div *ngIf="isProfessionalAreaOpen"
          class="absolute z-20 mt-1 w-full bg-white rounded-2xl shadow-lg border border-teal-600 focus:outline-none overflow-hidden">
          <div
            class="max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-teal-600 scrollbar-track-transparent">
            <ul class="py-2 text-base md:text-base sm:text-sm text-ferrerText!">
              <li *ngFor="let option of professionalAreas" (click)="selectProfessionalArea(option.value, $event)"
                class="px-4 py-3 hover:bg-ferrerSecondary hover:text-white cursor-pointer transition">
                {{ option.label }}
              </li>
            </ul>
          </div>





        </div>

        <!-- Hidden native select (for form control) -->
        <select class="hidden" formControlName="profession">
          <option value="" disabled selected></option>
          <option *ngFor="let option of professionalAreas" [value]="option.value">{{ option.label }}</option>
        </select>
      </div>

      <!-- Validation Error -->
      <div *ngIf="registrationForm.get('profession')?.invalid && registrationForm.get('profession')?.touched"
        class="text-base text-red-500 mt-1 ml-2 flex items-center" style="margin-top: 2px !important;">
        <mat-icon class="text-red-500 mr-1"
          style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
        <div *ngIf="registrationForm.get('profession')?.errors?.['required']">
          {{'validations.dropdownRequired' | transloco}}
        </div>
      </div>

      <!-- Country Dropdown -->
      <div class="mb-0 relative custom-dropdown-floating-label"
        [ngClass]="{'has-value': registrationForm.get('country')?.value}">
        <label for="countryTrigger" *ngIf="registrationForm.get('country')?.value">
          {{'registerPlaceholders.countryplaceholder' | transloco}}
        </label>
        <!-- Country Dropdown Header with Search Input -->
        <div id="countryTrigger"
          class="w-full border border-ferrerSecondary rounded-2xl focus-within:ring-2 focus-within:ring-teal-600 focus-within:border-transparent cursor-pointer flex justify-between items-center text-ferrerText"
          [ngClass]="{
    'border-red-500': registrationForm.get('country')?.invalid && registrationForm.get('country')?.touched,
    'is-open': isCountryOpen
  }" (click)="$event.target.tagName !== 'INPUT' ? toggleCountryDropdown($event) : null">
          <!-- Search input for countries -->
          <input type="text"
            class="w-full bg-transparent outline-none border-none focus:ring-0 text-ferrerText placeholder:text-ferrerText"
            [placeholder]="getCountryLabel(registrationForm.get('country')?.value) || ('registerPlaceholders.countryplaceholder' | transloco)"
            [(ngModel)]="countrySearchTerm" (input)="filterCountries()" (focus)="openCountryDropdown()"
            (click)="openCountryDropdown($event)" [ngModelOptions]="{standalone: true}" />

          <!-- Dropdown arrow -->
          <svg class="h-5 w-5 text-gray-500 transition-transform duration-200 ml-2 flex-shrink-0"
            [ngClass]="{'transform rotate-180': isCountryOpen}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
            fill="currentColor">
            <path fill-rule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 011.08 1.04l-4.25 4.25a.75.75 0 01-1.08 0l-4.25-4.25a.75.75 0 01.02-1.06z"
              clip-rule="evenodd" />
          </svg>
        </div>

        <!-- Dropdown Menu (Hidden by default) -->
        <div *ngIf="isCountryOpen"
          class="absolute z-20 mt-1 w-full bg-white rounded-2xl shadow-lg border border-teal-600 focus:outline-none overflow-hidden ">
          <div
            class="max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-teal-600 scrollbar-track-transparent country-dropdown-scroll">
            <ul class="py-2 text-base md:text-base sm:text-sm text-ferrerText!">
              <!-- No results message -->
              <li *ngIf="filteredCountries.length === 0" class="px-4 py-3 text-gray-500">
                {{'general.noResultsFound' | transloco}}
              </li>

              <!-- Country options -->
              <li *ngFor="let option of filteredCountries" (click)="selectCountry(option.value, $event)"
                class="px-4 py-3 hover:bg-ferrerSecondary hover:text-white cursor-pointer transition country-item">
                {{ option.label }}
              </li>
            </ul>
          </div>
        </div>

        <!-- Hidden native select (for form control) -->
        <select class="hidden" formControlName="country">
          <option value="" disabled selected></option>
          <option *ngFor="let option of countries" [value]="option.value">{{ option.label }}</option>
        </select>

        <!-- Validation Error -->
        <div *ngIf="registrationForm.get('country')?.invalid && registrationForm.get('country')?.touched"
          class="text-base text-red-500 mt-1 ml-2 flex items-center">
          <mat-icon class="text-red-500 mr-1"
            style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
          <div *ngIf="registrationForm.get('country')?.errors?.['required']">
            {{'validations.dropdownRequired' | transloco}}
          </div>
        </div>
      </div>

      <!-- Cedula -->
      <div *ngIf="showCedulaField()" class="mb-4">
        <div class="mb-1 floating-label">
          <input type="text" formControlName="cedula"
            [placeholder]="'registerPlaceholders.cedulaplaceholder' | transloco" required
            class="w-full border border-ferrerSecondary rounded-2xl focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent"
            [ngClass]="{'border-red-500': registrationForm.get('cedula')?.invalid && registrationForm.get('cedula')?.touched}" />
          <label for="cedula" class="floating-label">{{'registerPlaceholders.cedulaplaceholder' | transloco}}</label>
          <div *ngIf="registrationForm.get('cedula')?.invalid && registrationForm.get('cedula')?.touched"
            class="text-base text-red-500 mt-1 ml-2 flex items-center">

            <mat-icon class="text-red-500 mr-1"
              style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
            <div *ngIf="registrationForm.get('cedula')?.errors?.['required']">
              <span>{{'validations.cedulaRequired' | transloco}}</span>
            </div>
            <div
              *ngIf="registrationForm.get('cedula')?.errors?.pattern && !registrationForm.get('cedula')?.errors['whitespace']">
              {{'validations.cedulaPattern' | transloco}}
            </div>
            <div *ngIf="registrationForm.get('cedula')?.errors?.['whitespace']">
              {{'validations.noWhitespaceValidator' | transloco}}
            </div>
          </div>
        </div>
      </div>

      <hr class="my-6" />

      <!-- Postal + Phone with responsive layout -->
      <div class="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-2">
        <!-- Postal Code -->
        <div class="mb-1 w-full md:w-[44%] floating-label">
          <input type="text" formControlName="postalCode"
            [placeholder]="'registerPlaceholders.postalcodeplaceholder' | transloco"
            class="w-full border border-ferrerSecondary rounded-2xl focus:outline-none focus:ring-2 focus:ring-teal-600 focus:border-transparent"
            [ngClass]="{'border-red-500': registrationForm.get('postalCode')?.invalid && registrationForm.get('postalCode')?.touched}" />
          <label for="postalCode" class="floating-label">
            {{ (isPostalRequired()
            ? 'registerPlaceholders.postalcodeplaceholder'
            : 'registerPlaceholders.postalcodeNonMandatoryplaceholder') | transloco }}
          </label>
          <div *ngIf="registrationForm.get('postalCode')?.invalid && registrationForm.get('postalCode')?.touched"
            class="text-base text-red-500 mt-1 ml-2 flex items-center">
            <mat-icon class="text-red-500 mr-1"
              style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
            <div *ngIf="registrationForm.get('postalCode')?.errors?.['required']">
              {{'validations.postalRequired' | transloco}}
            </div>
            <div
              *ngIf="registrationForm.get('postalCode')?.errors?.['minlength'] && registrationForm.get('postalCode')?.errors?.pattern">
              {{'validations.postalCodePattern' | transloco}}
            </div>
            <div
              *ngIf="registrationForm.get('postalCode')?.errors?.['maxlength'] && !registrationForm.get('postalCode')?.errors?.pattern ">
              {{'validations.postalCodePattern' | transloco}}
            </div>
            <div
              *ngIf="registrationForm.get('postalCode')?.errors?.pattern && !registrationForm.get('postalCode')?.errors['whitespace']">
              {{'validations.postalCodePattern' | transloco}}
            </div>
            <div *ngIf="registrationForm.get('postalCode')?.errors?.['whitespace']">
              {{'validations.noWhitespaceValidator' | transloco}}
            </div>
          </div>
        </div>

        <!-- Phone -->
        <div class="w-full md:w-[56%] ">
          <div
            class="phone-input-container flex items-center rounded-2xl border border-ferrerSecondary bg-white font-dm w-full relative"
            style="height: 60px;" [ngClass]="{
         'border-red-500': registrationForm.get('telephone')?.invalid && registrationForm.get('telephone')?.touched,
         'focused': isPhoneComponentFocused
       }">

            <!-- Country Code Dropdown -->
            <div class="relative dropdown-wrapper inline-block text-left font-dm h-full"
              style="width: 70px; min-width:70px; flex: 0 0 auto;">
              <!-- Trigger Button - Improved click handling -->
              <div (click)="toggleDropdown($event)"
                class="inline-flex justify-between items-center h-full bg-white px-2 text-base md:text-base font-semibold text-ferrerText focus:outline-none cursor-pointer">
                <input type="text"
                  class="w-full bg-transparent outline-none border-none focus:ring-0 cursor-pointer text-ferrerText placeholder:text-ferrerText"
                  [placeholder]="selectedCountryCode.prefix" [(ngModel)]="dialCodeSearchTerm"
                  (input)="filterDialCodes()" (focus)="isPhoneComponentFocused = true; isOpen = true;"
                  (blur)="checkPhoneFocus()" (click)="$event.stopPropagation(); isOpen = true; $event.preventDefault();"
                  [ngModelOptions]="{standalone: true}" />

                <!-- Dropdown arrow -->
                <svg class="w-4 h-4 ml-1 text-ferrerSecondary flex-shrink-0 cursor-pointer"
                  [ngClass]="{'transform rotate-180': isOpen}" viewBox="0 0 20 20" fill="currentColor"
                  (click)="$event.stopPropagation(); toggleDropdown($event);">
                  <path fill-rule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 10.939l3.71-3.71a.75.75 0 011.08 1.04l-4.25 4.25a.75.75 0 01-1.08 0l-4.25-4.25a.75.75 0 01.02-1.06z"
                    clip-rule="evenodd" />
                </svg>
              </div>

              <!-- Dropdown Menu -->
              <div *ngIf="isOpen"
                class="absolute z-10 mt-2 w-full rounded-2xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none text-ferrerText!">
                <ul class="py-2 text-base md:text-base sm:text-base text-ferrerText! max-h-60 overflow-auto">
                  <li *ngIf="filteredDialCodes.length === 0" class="px-4 py-3 text-gray-500">
                    {{'general.noResultsFound' | transloco}}
                  </li>

                  <li *ngFor="let code of filteredDialCodes" (click)="selectCode(code)"
                    class="cursor-pointer px-4 py-3 hover:bg-ferrerSecondary hover:text-white transition rounded-md">
                    <span class="font-semibold">{{ code.label }}</span>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Seamless Vertical Separator (no gaps) -->
            <div class="h-2/3 border-l border-ferrerSecondary mx-1"></div>

            <!-- Phone Input with in-box Floating Label -->
            <div class="phone-floating-label flex-grow">
              <input type="text" id="telephone" formControlName="telephone" placeholder=" "
                class="w-full text-base md:text-base sm:text-sm border-0 focus:ring-0 focus:outline-none h-full bg-transparent px-3 text-ferrerText"
                (focus)="isPhoneComponentFocused = true" (blur)="checkPhoneFocus()" />
              <label for="telephone" class="phone-label">{{'registerPlaceholders.phoneplaceholder' | transloco}}</label>
            </div>
          </div>

          <!-- Error Messages - Prioritized -->
          <div *ngIf="registrationForm.get('telephone')?.invalid && registrationForm.get('telephone')?.touched"
            class="text-base text-red-500 mt-1 ml-2 flex items-center">
            <mat-icon class="text-red-500 mr-1"
              style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
            <div *ngIf="registrationForm.get('telephone')?.errors?.['required']">
              <span>{{'validations.phoneRequired' | transloco}}</span>
            </div>
            <div
              *ngIf="!registrationForm.get('telephone')?.errors?.['required'] && registrationForm.get('telephone')?.errors?.['pattern']">
              <span>{{'validations.phoneDigitsOnly' | transloco}}</span>
            </div>
            <div
              *ngIf="!registrationForm.get('telephone')?.errors?.['required'] && !registrationForm.get('telephone')?.errors?.['pattern'] && registrationForm.get('telephone')?.errors?.['minlength']">
              <span>{{'validations.wrongPhoneFormat' | transloco }}</span>
            </div>
            <div
              *ngIf="!registrationForm.get('telephone')?.errors?.['required'] && !registrationForm.get('telephone')?.errors?.['pattern'] && !registrationForm.get('telephone')?.errors?.['minlength'] && registrationForm.get('telephone')?.errors?.['maxlength']">
              <span>{{'validations.wrongPhoneFormat' | transloco }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Checkboxes -->
      <hr class="my-6" />

      <div class="space-y-5 text-base md:text-base text-gray-700">
        <!-- Main Consent -->
        <!-- Main Consent with Sub-consents -->
        <div class="mb-1">
          <ul class="space-y-4 w-full">
            <!-- Main consent checkbox -->
            <!-- Main consent checkbox -->
            <li *ngIf="subConsentsFormArray.length > 0" class="flex items-start space-x-2">
              <div class="custom-checkbox-container mt-1">
                <input type="checkbox" id="mainConsent" formControlName="mainConsent"
                  class="custom-checkbox visually-hidden"
                  [ngClass]="{'is-invalid': registrationForm.get('mainConsent')?.invalid && registrationForm.get('mainConsent')?.touched}"
                  (change)="onMainConsentChange()" [disabled]="anySubConsentChecked" />
                <label for="mainConsent" class="custom-checkbox-label"></label>
              </div>
              <div class="flex flex-col">
                <label for="mainConsent" class="text-base md:text-base font-semibold">
                  {{ 'registerPlaceholders.mainCheckboxText' | transloco }}
                </label>
                <span class="text-base md:text-base">
                  {{ 'registerPlaceholders.mainCheckboxmMainText' | transloco }}
                </span>
              </div>

            </li>

            <!-- Sub-consents (always visible) -->
            <div formArrayName="subConsents">
              <div *ngFor="let control of subConsentsFormArray.controls; let i = index" class="mt-4">
                <li class="ml-6 flex items-start space-x-2">
                  <div [formGroupName]="i" class="custom-checkbox-container">
                    <input type="checkbox" [id]="'subConsent' + i" formControlName="checked"
                      class="custom-checkbox visually-hidden" (change)="onSubConsentChange()"
                      [disabled]="registrationForm.get('mainConsent')?.value" />
                    <label [for]="'subConsent' + i" class="custom-checkbox-label"></label>
                  </div>

                  <label [for]="'subConsent' + i" class="text-sm md:text-sm">
                    {{ control.get('content')?.value }}
                  </label>
                </li>
              </div>
            </div>

          </ul>
          <div *ngIf="subConsentsFormArray.length > 0">
            <hr class="my-6" />
          </div>
          <!-- Validation error message -->
          <div *ngIf="registrationForm.get('mainConsent')?.invalid && registrationForm.get('mainConsent')?.touched"
            class="text-base text-red-500 mt-1 ml-2 flex items-center">
            <mat-icon class="text-red-500 mr-1"
              style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
            <div *ngIf="registrationForm.get('mainConsent')?.errors?.['required']">
              {{'validations.requiredConsent' | transloco}}
            </div>
          </div>
        </div>

        <!-- Terms Consent with Hand Icon -->
        <div class="mb-1">
          <label class="flex items-start space-x-3">
            <div class="custom-checkbox-container mt-1">
              <input type="checkbox" id="termsConsent" formControlName="termsConsent"
                class="custom-checkbox visually-hidden"
                [ngClass]="{'is-invalid': registrationForm.get('termsConsent')?.invalid && registrationForm.get('termsConsent')?.touched}" />
              <label for="termsConsent" class="custom-checkbox-label"></label>
            </div>
            <span>
              <span>{{'register.termsprivacyMainText' | transloco}} <a (click)="goToTermsStep()"
                  class="text-[#006E75] hover:text-[#003E42] underline hover:underline cursor-pointer">{{'register.termsanchourButton'
                  | transloco}}</a> {{'general.termslink' | transloco}} <a (click)="gotoUserPrivacyStep()"
                  class="text-[#006E75] hover:text-[#003E42] underline hover:underline cursor-pointer">{{'register.userprivacyanchourButton'
                  | transloco}}</a></span><br />
              <div
                *ngIf="registrationForm.get('termsConsent')?.invalid && registrationForm.get('termsConsent')?.touched"
                class="text-base text-red-500 mt-1 flex items-center">
                <mat-icon class="text-red-500 mr-1"
                  style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
                <div *ngIf="registrationForm.get('termsConsent')?.errors?.['required']">
                  {{'validations.consentMissing' | transloco}}
                </div>
              </div>
              <div class="text-sm md:text-sm" [innerHTML]="protectionInformation"></div>
            </span>
          </label>

        </div>
        <!-- consent special data processing with hand icon-->
        <div *ngIf="showSpecialDataProcessingField()" class="mb-1">
          <label class="flex items-start space-x-3">
            <div class="custom-checkbox-container mt-1">
              <input type="checkbox" id="ConsentSpecialDataProcessing" formControlName="ConsentSpecialDataProcessing"
                class="custom-checkbox visually-hidden"
                [ngClass]="{'is-invalid': registrationForm.get('ConsentSpecialDataProcessing')?.invalid && registrationForm.get('ConsentSpecialDataProcessing')?.touched}" />
              <label for="ConsentSpecialDataProcessing" class="custom-checkbox-label"></label>
            </div>
            <span
              [innerHTML]="'register.registerConsentSpecialDataProcessing' | transloco:{grupoFerrerLink: grupoFerrerLinkHtml}">
            </span>
          </label>
          <div
            *ngIf="registrationForm.get('ConsentSpecialDataProcessing')?.invalid && registrationForm.get('ConsentSpecialDataProcessing')?.touched"
            class="text-base flex items-center text-red-500 mt-1 ml-2">
            <mat-icon class="text-red-500 mr-1"
              style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
            <div *ngIf="registrationForm.get('ConsentSpecialDataProcessing')?.errors?.['required']">
              {{'validations.requiredConsent' | transloco}}
            </div>
          </div>
        </div>

        <!-- consent special partners with hand icon-->
        <div *ngIf="showSpecialPartnersField()" class="mb-1">
          <label class="flex items-start space-x-3">
            <div class="custom-checkbox-container mt-1">
              <input type="checkbox" id="ConsentSpecialPartners" formControlName="ConsentSpecialPartners"
                class="custom-checkbox visually-hidden"
                [ngClass]="{'is-invalid': registrationForm.get('ConsentSpecialPartners')?.invalid && registrationForm.get('ConsentSpecialPartners')?.touched}" />
              <label for="ConsentSpecialPartners" class="custom-checkbox-label"></label>
            </div>
            <span>
              {{'register.registerConsentSpecialPartners' | transloco}}
            </span>
          </label>
          <div
            *ngIf="registrationForm.get('ConsentSpecialPartners')?.invalid && registrationForm.get('ConsentSpecialPartners')?.touched"
            class="text-base flex items-center text-red-500 mt-1 ml-2">
            <mat-icon class="text-red-500 mr-1"
              style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
            <div *ngIf="registrationForm.get('ConsentSpecialPartners')?.errors?.['required']">
              {{'validations.requiredConsent' | transloco}}
            </div>
          </div>
        </div>
        <!-- Data Consent with Hand Icon -->
        <div *ngIf="showDataConsentField()" class="mb-1">
          <label class="flex items-start space-x-3">
            <div class="custom-checkbox-container mt-1">
              <input type="checkbox" id="dataConsent" formControlName="dataConsent"
                class="custom-checkbox visually-hidden"
                [ngClass]="{'is-invalid': registrationForm.get('dataConsent')?.invalid && registrationForm.get('dataConsent')?.touched}" />
              <label for="dataConsent" class="custom-checkbox-label"></label>
            </div>
            <span>
              {{'register.registerdataTreamentMaintext' | transloco}}
            </span>
          </label>
          <div *ngIf="registrationForm.get('dataConsent')?.invalid && registrationForm.get('dataConsent')?.touched"
            class="text-base flex items-center text-red-500 mt-1 ml-2">
            <mat-icon class="text-red-500 mr-1"
              style="font-size: 16px; height: 16px; width: 16px; margin-bottom: 2px;">error_outline</mat-icon>
            <div *ngIf="registrationForm.get('dataConsent')?.errors?.['required']">
              {{'validations.requiredConsent' | transloco}}
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>



  <!-- Submit Button -->
  <div *ngIf="registerApiError"
    class="w-full max-w-md mt-4 p-3 rounded-md text-red-600 text-base flex items-center justify-center">
    <mat-icon class="mr-2 text-red-500 icon-size-5">error_outline</mat-icon>
    <span>{{ registerApiError }}</span>
  </div>
  <button type="submit" (click)="onSubmit()"
    class="w-full my-button mb-4 bg-teal-700 hover:bg-teal-800 text-white py-4 rounded-full text-base md:text-sm font-semibold shadow transition h-14 ">
    <div class="flex items-center justify-center">
      <span *ngIf="!isSubmitting">{{'register.registerVerifiedButton' | transloco}}</span>
      <svg *ngIf="!isSubmitting" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-1" viewBox="0 0 20 20"
        fill="currentColor">
        <path fill-rule="evenodd"
          d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H7a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
          clip-rule="evenodd" />
      </svg>
      <div *ngIf="isSubmitting" class="flex justify-center items-center">
        <svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
          </path>
        </svg>
        <span class="ml-2">{{'general.processing' | transloco}}</span>
      </div>
    </div>
  </button>


</div>